import React, { useState } from 'react';
import RightNavBar from './RightNavBar';
import InfoCard from './InfoCard';
import InfoCardContent from './InfoCardContent';
import FilterList from './FilterList';

function Education() {
    const columbiaContent = ["Master's in Computer Science", "Computer Graphics and Vision Track", "September 2020 - May 2022", "GPA: 4.0"];
    const columbiaMoreInfo = ["Advanced Software Engineering", "User Interface Design", "Computer Vision I", "Computer Graphics", "Computer Science Projects", "Intro to Computational Learning"]
    const columbiaCard = <InfoCard 
        headerImg={"images/logo_columbia.png"} 
        content={InfoCardContent(columbiaContent)} 
        tag="Postgraduate"
        more={<ul>{columbiaMoreInfo.map((item, index) => <li key={index}><i className="fa fa-angle-right" />  {item}</li>)}</ul>}
        moreInfo="Relevant Courses" 
    />;

    const polytechContent = ["Bachelor's in Mathematics and Computer Science", "Minor in Biology", "September 2017 - June 2020", "GPA: 3.6"];
    const polytechMoreInfoCS = ["Object-oriented Programming in C++", "Introduction to Algorithms", "Design and Analysis of Algorithms", "Web Programming", "Machine Learning"];
    const polytechMoreInfoMath = ["Linear Algebra", "Discrete Mathematics", "Logic and Proofs", "Computational Mathematics"];
    const polytechCard = <InfoCard 
        headerImg={"images/logo_poly.png"} 
        content={InfoCardContent(polytechContent)} 
        tag="Undergraduate"
        more={<ul>{polytechMoreInfoCS.map((item, index) => <li key={index}><i className="fa fa-angle-right" />  {item}</li>)}
        <br />
        {polytechMoreInfoMath.map((item, index) => <li key={index}><i className="fa fa-angle-right" />  {item}</li>)}</ul>}
        moreInfo="Relevant Courses"
    />

    const kingsContent = ["Exchange Semester (Part of Bachelor's degree)", "Mathematics and Computer Science", "September 2019 - December 2019", "First-class honors"];
    const kingsMoreInfo = ["Compilers and Formal Languages", "Cryptography"];
    const kingsCard = <InfoCard 
        headerImg={"images/logo_kcl.png"} 
        content={InfoCardContent(kingsContent)} 
        tag="Exchange"
        more={<ul>{kingsMoreInfo.map((item, index) => <li key={index}><i className="fa fa-angle-right" />  {item}</li>)}</ul>}
        moreInfo="Relevant Courses"
    />
    
    const msContent = ["Introduction to Game Development", "Online course", "Using Unity 2020", "Developed 3 Unity games (both 2D and 3D)"]
    const msCard = <InfoCard 
        headerImg={"images/logo-ms.png"} 
        content={InfoCardContent(msContent)} 
        tag="Online Course"
        more={null}
    />

    const mlContent = ["Neural Networks and Deep Learning", "Online course", "Python, Jupyter Notebooks", "Linear regression, shallow and deep neural networks"]
    const mlCard = <InfoCard 
        headerImg={"images/logo_ml.png"} 
        content={InfoCardContent(mlContent)} 
        tag="Online Course"
        more={null}
    />

    const codeContent = ["ReactJS", "Online course", "JSX, Components, Lifecycle Methods, Hooks"]
    const codeCard = <InfoCard 
        headerImg={"images/logo_code.png"} 
        content={InfoCardContent(codeContent)} 
        tag="Online Course"
        more={null}
    />

    const educationFilter = {
        "All": [columbiaCard, polytechCard, kingsCard, msCard, mlCard, codeCard],
        "Universities": [columbiaCard, polytechCard, kingsCard],
        "Degree offering": [columbiaCard, polytechCard],
        "Master's degree": [columbiaCard],
        "Bachelor's degree": [polytechCard, kingsCard],
        "Online courses": [msCard, mlCard, codeCard],
    }
    const filters = Object.keys(educationFilter);

    const [ filter, setFilter ] = useState("All");
    const chooseFilter = (item) => {
        setFilter(item);
    }

    return (
        <>
            <div className="page-content">
                {educationFilter[filter]}
            </div>
            <RightNavBar>
                <div className="question-caption italic-element">
                    Click to filter the results:
                </div>
                <FilterList filters={filters} onFilterClick={chooseFilter} key="education-rnb" />
            </RightNavBar>
        </>
    )
}

export default Education;